module.exports = __webpack_public_path__ + "static/img/heisexi.3e8e64f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/heisexi.png
// module id = DW86
// module chunks = 3